import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	Resolve,
	Router,
	RouterStateSnapshot
} from "@angular/router";
import { ClientMessages } from "@hub/generated/_messages";
import { UserDetailDto } from "@hub/generated/models";
import { ReferenceController, SettingsController } from "@hub/generated/services";
import {
	AuthService,
	CurrentUserService,
	NotificationService,
	SessionStorageService
} from "@hub/services/index";
import { Observable } from "rxjs";
import { map, retry } from "rxjs/operators";
import { LookUps } from "../common/LookUps";

@Injectable({ providedIn: 'root' })
export class UserResolver implements Resolve<UserDetailDto> {
	constructor(
		private settingsController: SettingsController,
		private auth: AuthService,
		private currentUser: CurrentUserService,
		private router: Router,
		public referenceController: ReferenceController,
		private notificationService: NotificationService,
		private storageService: SessionStorageService
	) {
	}

	// Private Fields
	private _isLoaded: boolean = false;
	private _user: Observable<UserDetailDto>;

	public SetEnumsLists() {
		if (!!this.storageService.get("lookUpData")) {
			LookUps.EnumList = this.storageService.get("lookUpData");
		} else {
			this.referenceController
				.GetEnumsList()
				.pipe(retry(3))
				.subscribe(
					data => {
						LookUps.EnumList = data;
						this.storageService.set("lookUpData", data);
					},
					err => {
						this.notificationService.error(ClientMessages.BaseErrorMessage);
					}
				);
		}

		if (!!this.storageService.get("countryData")) {
			LookUps.CountryList = this.storageService.get("countryData");
		} else {
			this.referenceController
				.GetCountriessDto()
				.pipe(retry(3))
				.subscribe(
					data => {
						LookUps.CountryList = data;
						this.storageService.set("countryData", data);
					},
					err => {
						this.notificationService.error(ClientMessages.BaseErrorMessage);
					}
				);
		}
	}

	// Resolve overrides
	public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserDetailDto> {
		if (!this.auth.isLogged) {
			this.auth.redirectUrl = this.router.url;
			this.router.navigateByUrl("/login");
		} else {
			if (!this._isLoaded) {
				let user = this.settingsController.GetCurrentUser()
					.pipe(map(u => {
						this.currentUser.load(u);
						this._isLoaded = true;
						return u;
					})
					);

				this.SetEnumsLists();
				this._user = user;
				return user;
			}
		}
		return this._user;
	}
}
